var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-breadcrumb-item',[(_vm.bread.name != 'principal')?_c('router-link',{attrs:{"to":{ name: _vm.bread.name }}},[(_vm.bread.meta.icon)?_c('a-icon',{staticClass:"icon",staticStyle:{"color":"#fff"},attrs:{"type":_vm.bread.meta.icon}}):_vm._e(),_c('span',{staticStyle:{"color":"#fff"}},[_vm._v(_vm._s(_vm.bread.meta.description))])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }